/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-selection");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"c-arrow":"index__c-arrow___3FzOJ","c-arrow--t":"index__c-arrow--t___1AEby","c-arrow--tl":"index__c-arrow--tl___1Dins","c-arrow--tr":"index__c-arrow--tr___1PDZc","c-arrow--r":"index__c-arrow--r___2Tdnx","c-arrow--rb":"index__c-arrow--rb___2IfRl","c-arrow--rt":"index__c-arrow--rt___1iPGw","c-arrow--l":"index__c-arrow--l___yf4Mt","c-arrow--lb":"index__c-arrow--lb___2ZN6L","c-arrow--lt":"index__c-arrow--lt___biHXW","c-arrow--b":"index__c-arrow--b___Bo2Gt","c-arrow--bl":"index__c-arrow--bl___2tMZQ","c-arrow--br":"index__c-arrow--br___S8ORZ"};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"c-tooltip":"index__c-tooltip___3EGHJ","c-arrow":"index__c-arrow___2Lid2","c-tooltip--extra-large":"index__c-tooltip--extra-large___1wCgw","c-tooltip--large":"index__c-tooltip--large___1sEmC","c-tooltip--medium":"index__c-tooltip--medium___K7htT","c-tooltip__paragraph":"index__c-tooltip__paragraph___11fiJ","c-tooltip__title":"index__c-tooltip__title___2Tzx4","is-rtl":"index__is-rtl___1RCiX","c-tooltip--light":"index__c-tooltip--light___nZDli"};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@zendeskgarden/react-theming");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("react-popper");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("react-portal");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("render-fragment");

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(6);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(4);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@zendeskgarden/react-selection"
var react_selection_ = __webpack_require__(1);

// EXTERNAL MODULE: external "react-popper"
var external_react_popper_ = __webpack_require__(8);

// EXTERNAL MODULE: external "react-portal"
var external_react_portal_ = __webpack_require__(9);

// EXTERNAL MODULE: external "render-fragment"
var external_render_fragment_ = __webpack_require__(10);
var external_render_fragment_default = /*#__PURE__*/__webpack_require__.n(external_render_fragment_);

// EXTERNAL MODULE: external "@zendeskgarden/react-theming"
var react_theming_ = __webpack_require__(5);

// CONCATENATED MODULE: ./src/utils/gardenPlacements.js
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */
var SHARED_PLACEMENTS = {
  AUTO: 'auto',
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end'
};
var GARDEN_PLACEMENTS = _objectSpread({}, SHARED_PLACEMENTS, {
  END: 'end',
  END_TOP: 'end-top',
  END_BOTTOM: 'end-bottom',
  START: 'start',
  START_TOP: 'start-top',
  START_BOTTOM: 'start-bottom'
});
var POPPER_PLACEMENTS = _objectSpread({}, SHARED_PLACEMENTS, {
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
});
/**
 * Convert Garden RTL aware placement to Popper.JS valid placement
 * @param {String} gardenPlacement
 */

function getPopperPlacement(gardenPlacement) {
  var _objectSpread2;

  var sharedPlacements = {};

  for (var KEY in SHARED_PLACEMENTS) {
    if (Object.prototype.hasOwnProperty.call(SHARED_PLACEMENTS, KEY)) {
      var value = SHARED_PLACEMENTS[KEY];
      sharedPlacements[value] = value;
    }
  }

  var GARDEN_POPPER_MAPPINGS = _objectSpread({}, sharedPlacements, (_objectSpread2 = {}, _defineProperty(_objectSpread2, GARDEN_PLACEMENTS.END, POPPER_PLACEMENTS.RIGHT), _defineProperty(_objectSpread2, GARDEN_PLACEMENTS.END_TOP, POPPER_PLACEMENTS.RIGHT_START), _defineProperty(_objectSpread2, GARDEN_PLACEMENTS.END_BOTTOM, POPPER_PLACEMENTS.RIGHT_END), _defineProperty(_objectSpread2, GARDEN_PLACEMENTS.START, POPPER_PLACEMENTS.LEFT), _defineProperty(_objectSpread2, GARDEN_PLACEMENTS.START_TOP, POPPER_PLACEMENTS.LEFT_START), _defineProperty(_objectSpread2, GARDEN_PLACEMENTS.START_BOTTOM, POPPER_PLACEMENTS.LEFT_END), _objectSpread2));

  return GARDEN_POPPER_MAPPINGS[gardenPlacement];
}
/**
 * Convert Garden RTL aware placement to RTL equivalent Popper.JS placement
 * @param {String} gardenPlacement
 */

function getRtlPopperPlacement(gardenPlacement) {
  var _RTL_PLACEMENT_MAPPIN;

  var RTL_PLACEMENT_MAPPINGS = (_RTL_PLACEMENT_MAPPIN = {}, _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT, POPPER_PLACEMENTS.RIGHT), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT_START, POPPER_PLACEMENTS.RIGHT_START), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.LEFT_END, POPPER_PLACEMENTS.RIGHT_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.TOP_START, POPPER_PLACEMENTS.TOP_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.TOP_END, POPPER_PLACEMENTS.TOP_START), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT, POPPER_PLACEMENTS.LEFT), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT_START, POPPER_PLACEMENTS.LEFT_START), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.RIGHT_END, POPPER_PLACEMENTS.LEFT_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.BOTTOM_START, POPPER_PLACEMENTS.BOTTOM_END), _defineProperty(_RTL_PLACEMENT_MAPPIN, POPPER_PLACEMENTS.BOTTOM_END, POPPER_PLACEMENTS.BOTTOM_START), _RTL_PLACEMENT_MAPPIN);
  var popperPlacement = getPopperPlacement(gardenPlacement);
  return RTL_PLACEMENT_MAPPINGS[popperPlacement] || popperPlacement;
}
// CONCATENATED MODULE: ./src/containers/TooltipContainer.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function TooltipContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { TooltipContainer_defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function TooltipContainer_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */









/**
 * This container must provide a wrapper for the provided tooltip
 * due to constraints in our arrow css. We must ensure that the container
 * of the tooltip can retain it's relative positioning. Without this
 * container Popper would apply absolute positioning.
 */

var TooltipWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "TooltipContainer__TooltipWrapper",
  componentId: "mr0hf4-0"
})(["z-index:", ";&[aria-hidden='true']{display:none;}"], function (props) {
  return props.zIndex;
});

var TooltipContainer_TooltipContainer =
/*#__PURE__*/
function (_ControlledComponent) {
  _inherits(TooltipContainer, _ControlledComponent);

  function TooltipContainer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TooltipContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TooltipContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    TooltipContainer_defineProperty(_assertThisInitialized(_this), "openTooltip", function () {
      var delayMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.delayMilliseconds;
      clearTimeout(_this.closeTooltipTimeout);
      _this.openTooltipTimeout = setTimeout(function () {
        _this.setControlledState({
          isVisible: true
        });
      }, delayMilliseconds);
    });

    TooltipContainer_defineProperty(_assertThisInitialized(_this), "closeTooltip", function () {
      var delayMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.delayMilliseconds;
      clearTimeout(_this.openTooltipTimeout);
      _this.closeTooltipTimeout = setTimeout(function () {
        _this.setControlledState({
          isVisible: false
        });
      }, delayMilliseconds);
    });

    TooltipContainer_defineProperty(_assertThisInitialized(_this), "getTriggerProps", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$tabIndex = _ref.tabIndex,
          tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
          onMouseEnter = _ref.onMouseEnter,
          onMouseLeave = _ref.onMouseLeave,
          onFocus = _ref.onFocus,
          onBlur = _ref.onBlur,
          other = _objectWithoutProperties(_ref, ["tabIndex", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"]);

      return TooltipContainer_objectSpread({
        tabIndex: tabIndex,
        onMouseEnter: Object(react_selection_["composeEventHandlers"])(onMouseEnter, function () {
          return _this.openTooltip();
        }),
        onMouseLeave: Object(react_selection_["composeEventHandlers"])(onMouseLeave, function () {
          return _this.closeTooltip();
        }),
        onFocus: Object(react_selection_["composeEventHandlers"])(onFocus, function () {
          return _this.openTooltip();
        }),
        // Close menu immediately when blurred
        onBlur: Object(react_selection_["composeEventHandlers"])(onBlur, function () {
          return _this.closeTooltip(0);
        })
      }, other);
    });

    TooltipContainer_defineProperty(_assertThisInitialized(_this), "getTooltipProps", function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$role = _ref2.role,
          role = _ref2$role === void 0 ? 'tooltip' : _ref2$role,
          onMouseEnter = _ref2.onMouseEnter,
          onMouseLeave = _ref2.onMouseLeave,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          other = _objectWithoutProperties(_ref2, ["role", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"]);

      return TooltipContainer_objectSpread({
        role: role,
        onMouseEnter: Object(react_selection_["composeEventHandlers"])(onMouseEnter, function () {
          return _this.openTooltip();
        }),
        onMouseLeave: Object(react_selection_["composeEventHandlers"])(onMouseLeave, function () {
          return _this.closeTooltip();
        }),
        onFocus: Object(react_selection_["composeEventHandlers"])(onFocus, function () {
          return _this.openTooltip();
        }),
        // Close menu after delay to mimic mouse interaction
        onBlur: Object(react_selection_["composeEventHandlers"])(onBlur, function () {
          return _this.closeTooltip();
        })
      }, other);
    });

    TooltipContainer_defineProperty(_assertThisInitialized(_this), "convertGardenToPopperPlacement", function () {
      var placement = _this.props.placement;

      if (Object(react_theming_["isRtl"])(_this.props)) {
        return getRtlPopperPlacement(placement);
      }

      return getPopperPlacement(placement);
    });

    _this.state = {
      isVisible: false,
      id: react_selection_["IdManager"].generateId('garden-tooltip-container')
    };
    _this.mouseEntered = true;
    return _this;
  }

  _createClass(TooltipContainer, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.openTooltipTimeout);
      clearTimeout(this.closeTooltipTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$render = _this$props.render,
          render = _this$props$render === void 0 ? children : _this$props$render,
          trigger = _this$props.trigger,
          eventsEnabled = _this$props.eventsEnabled,
          popperModifiers = _this$props.popperModifiers,
          appendToBody = _this$props.appendToBody,
          zIndex = _this$props.zIndex;

      var _this$getControlledSt = this.getControlledState(),
          isVisible = _this$getControlledSt.isVisible;

      return external_react_default.a.createElement(external_react_popper_["Manager"], {
        tag: false
      }, external_react_default.a.createElement(external_render_fragment_default.a, null, external_react_default.a.createElement(external_react_popper_["Target"], null, function (_ref3) {
        var targetProps = _ref3.targetProps;
        return trigger && trigger({
          getTriggerProps: function getTriggerProps(props) {
            return _this2.getTriggerProps(TooltipContainer_objectSpread({}, props));
          },
          ref: targetProps.ref,
          isVisible: isVisible
        });
      }), external_react_default.a.createElement(external_react_popper_["Popper"], {
        placement: this.convertGardenToPopperPlacement(),
        eventsEnabled: eventsEnabled,
        modifiers: popperModifiers
      }, function (_ref4) {
        var popperProps = _ref4.popperProps,
            scheduleUpdate = _ref4.scheduleUpdate;
        var popperPlacement = popperProps['data-placement'];
        var outOfBoundaries = popperProps['data-x-out-of-boundaries'];

        if (!isVisible) {
          return null;
        }

        var tooltip = external_react_default.a.createElement(TooltipWrapper, {
          innerRef: popperProps.ref,
          style: popperProps.style,
          zIndex: zIndex
        }, render({
          getTooltipProps: function getTooltipProps(props) {
            return _this2.getTooltipProps(props);
          },
          isVisible: isVisible,
          placement: popperPlacement,
          outOfBoundaries: outOfBoundaries,
          scheduleUpdate: scheduleUpdate
        }));

        if (appendToBody) {
          return external_react_default.a.createElement(external_react_portal_["Portal"], null, tooltip);
        }

        return tooltip;
      })));
    }
  }]);

  return TooltipContainer;
}(react_selection_["ControlledComponent"]);

TooltipContainer_defineProperty(TooltipContainer_TooltipContainer, "propTypes", {
  /** Appends the tooltip to the body element */
  appendToBody: external_prop_types_default.a.bool,

  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getTooltipProps - Props to be spread onto the tooltip element
   * @param {Function} renderProps.isVisible - Whether the Tooltip is currently visible
   * @param {Any} renderProps.placement - The current placement of the Tooltip. Will update based on boundary conflicts.
   * @param {Any} renderProps.outOfBoundaries - Whether the current tooltip has escaped it's boundary.
   * @param {Any} renderProps.scheduleUpdate - Method to force an update within Popper.js
   */
  children: external_prop_types_default.a.func,

  /** Milliseconds of delay before open/close of tooltip is initiated */
  delayMilliseconds: external_prop_types_default.a.number,

  /** Whether Popper.js should update based on DOM resize events */
  eventsEnabled: external_prop_types_default.a.bool,

  /** The root ID to use for descendants. A unique ID is created if none is provided.  */
  id: external_prop_types_default.a.string,

  /** Controls visibility of tooltip */
  isVisible: external_prop_types_default.a.bool,

  /** Returns all changed state. Used for controlling usage. */
  onStateChange: external_prop_types_default.a.func,

  /**
   * These placements differ from the default naming of Popper.JS placements to help
   * assist with RTL layouts.
   **/
  placement: external_prop_types_default.a.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),

  /** Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options) */
  popperModifiers: external_prop_types_default.a.object,

  /** Identical to children */
  render: external_prop_types_default.a.func,

  /**
   * @param {Object} renderProps
   * @param {Function} renderProps.getTriggerProps - Props to be spread onto the trigger element
   * @param {Function} renderProps.isVisible - Whether the Tooltip is currently visible
   * @param {Function} renderProps.ref - Callback to retrieve the trigger elements ref
   */
  trigger: external_prop_types_default.a.func,

  /**
   * The z-index of the popper.js placement container
   */
  zIndex: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string])
});

TooltipContainer_defineProperty(TooltipContainer_TooltipContainer, "defaultProps", {
  placement: 'top',
  eventsEnabled: true,
  delayMilliseconds: 500
});

/* harmony default export */ var containers_TooltipContainer = (Object(react_theming_["withTheme"])(TooltipContainer_TooltipContainer));
// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(7);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-arrows/dist/index.css
var dist = __webpack_require__(2);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-tooltips/dist/index.css
var css_tooltips_dist = __webpack_require__(3);
var css_tooltips_dist_default = /*#__PURE__*/__webpack_require__.n(css_tooltips_dist);

// CONCATENATED MODULE: ./src/views/TooltipView.js
function TooltipView_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */






var COMPONENT_ID = 'tooltip.tooltip';
var SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};
var PLACEMENT = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
};

var shouldShowArrow = function shouldShowArrow(_ref) {
  var arrow = _ref.arrow,
      placement = _ref.placement;
  return arrow && placement;
};

var retrieveTooltipMargin = function retrieveTooltipMargin(_ref2) {
  var arrow = _ref2.arrow,
      size = _ref2.size;

  if (arrow) {
    if (size === SIZE.LARGE) {
      return 'margin: 8px;';
    } else if (size === SIZE.EXTRA_LARGE) {
      return 'margin: 12px;';
    }
  }

  return 'margin: 6px';
};
/**
 * Accepts all `<div>` props
 */


var TooltipView = external_styled_components_default.a.div.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': "5.0.10",
  className: function className(props) {
    var _classNames;

    return external_classnames_default()(css_tooltips_dist_default.a['c-tooltip'], (_classNames = {}, TooltipView_defineProperty(_classNames, css_tooltips_dist_default.a['c-tooltip--medium'], props.size === SIZE.MEDIUM), TooltipView_defineProperty(_classNames, css_tooltips_dist_default.a['c-tooltip--large'], props.size === SIZE.LARGE), TooltipView_defineProperty(_classNames, css_tooltips_dist_default.a['c-tooltip--extra-large'], props.size === SIZE.EXTRA_LARGE), TooltipView_defineProperty(_classNames, css_tooltips_dist_default.a['c-arrow'], shouldShowArrow(props)), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow'], shouldShowArrow(props)), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--r'], props.placement === PLACEMENT.LEFT), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--rt'], props.placement === PLACEMENT.LEFT_START), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--rb'], props.placement === PLACEMENT.LEFT_END), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--b'], props.placement === PLACEMENT.TOP), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--bl'], props.placement === PLACEMENT.TOP_START), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--br'], props.placement === PLACEMENT.TOP_END), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--l'], props.placement === PLACEMENT.RIGHT), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--lt'], props.placement === PLACEMENT.RIGHT_START), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--lb'], props.placement === PLACEMENT.RIGHT_END), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--t'], props.placement === PLACEMENT.BOTTOM), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--tl'], props.placement === PLACEMENT.BOTTOM_START), TooltipView_defineProperty(_classNames, dist_default.a['c-arrow--tr'], props.placement === PLACEMENT.BOTTOM_END), TooltipView_defineProperty(_classNames, css_tooltips_dist_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
  }
}).withConfig({
  displayName: "TooltipView",
  componentId: "yjjo4k-0"
})(["", ";", ";"], function (props) {
  return retrieveTooltipMargin(props);
}, function (props) {
  return Object(react_theming_["retrieveTheme"])(COMPONENT_ID, props);
});
TooltipView.propTypes = {
  arrow: external_prop_types_default.a.bool,
  size: external_prop_types_default.a.oneOf([SIZE.SMALL, SIZE.MEDIUM, SIZE.LARGE, SIZE.EXTRA_LARGE]),

  /** All valid [Popper.JS Placements](https://popper.js.org/popper-documentation.html#Popper.placements) */
  placement: external_prop_types_default.a.oneOf([PLACEMENT.TOP, PLACEMENT.TOP_START, PLACEMENT.TOP_END, PLACEMENT.RIGHT, PLACEMENT.RIGHT_START, PLACEMENT.RIGHT_END, PLACEMENT.BOTTOM, PLACEMENT.BOTTOM_START, PLACEMENT.BOTTOM_END, PLACEMENT.LEFT, PLACEMENT.LEFT_START, PLACEMENT.LEFT_END])
};
TooltipView.defaultProps = {
  arrow: true,
  size: SIZE.SMALL
};
/** @component */

/* harmony default export */ var views_TooltipView = (TooltipView);
// CONCATENATED MODULE: ./src/views/LightTooltip.js
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */






var LightTooltip_COMPONENT_ID = 'tooltip.light_tooltip';
var LightTooltip_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};
var LightTooltip_PLACEMENT = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end'
};
/**
 * Accepts all `<div>` props
 */

var LightTooltip = external_styled_components_default()(views_TooltipView).attrs({
  'data-garden-id': LightTooltip_COMPONENT_ID,
  'data-garden-version': "5.0.10",
  className: external_classnames_default()(css_tooltips_dist_default.a['c-tooltip--light'])
}).withConfig({
  displayName: "LightTooltip",
  componentId: "sc-1ct2673-0"
})(["", ";"], function (props) {
  return Object(react_theming_["retrieveTheme"])(LightTooltip_COMPONENT_ID, props);
});
LightTooltip.propTypes = {
  arrow: external_prop_types_default.a.bool,
  size: external_prop_types_default.a.oneOf([LightTooltip_SIZE.SMALL, LightTooltip_SIZE.MEDIUM, LightTooltip_SIZE.LARGE, LightTooltip_SIZE.EXTRA_LARGE]),

  /** All valid [Popper.JS Placements](https://popper.js.org/popper-documentation.html#Popper.placements) */
  placement: external_prop_types_default.a.oneOf([LightTooltip_PLACEMENT.TOP, LightTooltip_PLACEMENT.TOP_START, LightTooltip_PLACEMENT.TOP_END, LightTooltip_PLACEMENT.RIGHT, LightTooltip_PLACEMENT.RIGHT_START, LightTooltip_PLACEMENT.RIGHT_END, LightTooltip_PLACEMENT.BOTTOM, LightTooltip_PLACEMENT.BOTTOM_START, LightTooltip_PLACEMENT.BOTTOM_END, LightTooltip_PLACEMENT.LEFT, LightTooltip_PLACEMENT.LEFT_START, LightTooltip_PLACEMENT.LEFT_END])
};
LightTooltip.defaultProps = {
  arrow: true,
  size: LightTooltip_SIZE.LARGE
};
/** @component */

/* harmony default export */ var views_LightTooltip = (LightTooltip);
// CONCATENATED MODULE: ./src/elements/Tooltip.js
function Tooltip_typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Tooltip_typeof = function _typeof(obj) { return typeof obj; }; } else { Tooltip_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Tooltip_typeof(obj); }

function Tooltip_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Tooltip_defineProperty(target, key, source[key]); }); } return target; }

function Tooltip_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Tooltip_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Tooltip_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Tooltip_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Tooltip_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Tooltip_createClass(Constructor, protoProps, staticProps) { if (protoProps) Tooltip_defineProperties(Constructor.prototype, protoProps); if (staticProps) Tooltip_defineProperties(Constructor, staticProps); return Constructor; }

function Tooltip_possibleConstructorReturn(self, call) { if (call && (Tooltip_typeof(call) === "object" || typeof call === "function")) { return call; } return Tooltip_assertThisInitialized(self); }

function Tooltip_getPrototypeOf(o) { Tooltip_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Tooltip_getPrototypeOf(o); }

function Tooltip_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Tooltip_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Tooltip_setPrototypeOf(subClass, superClass); }

function Tooltip_setPrototypeOf(o, p) { Tooltip_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Tooltip_setPrototypeOf(o, p); }

function Tooltip_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */







var Tooltip_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra-large'
};
var TYPE = {
  LIGHT: 'light',
  DARK: 'dark'
};
/**
 * Due to Popper.JS needing a reference to a component we provide a simple wrapper
 * to ensure the correct reference is provided.
 */

var TriggerWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "Tooltip__TriggerWrapper",
  componentId: "lty2bj-0"
})(["display:inline-block;"]);

var Tooltip_Tooltip =
/*#__PURE__*/
function (_ControlledComponent) {
  Tooltip_inherits(Tooltip, _ControlledComponent);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    Tooltip_classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Tooltip_possibleConstructorReturn(this, (_getPrototypeOf2 = Tooltip_getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Tooltip_defineProperty(Tooltip_assertThisInitialized(_this), "state", {
      id: react_selection_["IdManager"].generateId('garden-tooltip')
    });

    return _this;
  }

  Tooltip_createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appendToBody = _this$props.appendToBody,
          _trigger = _this$props.trigger,
          defaultPlacement = _this$props.placement,
          eventsEnabled = _this$props.eventsEnabled,
          popperModifiers = _this$props.popperModifiers,
          delayMilliseconds = _this$props.delayMilliseconds,
          type = _this$props.type,
          arrow = _this$props.arrow,
          children = _this$props.children,
          size = _this$props.size,
          zIndex = _this$props.zIndex,
          otherProps = Tooltip_objectWithoutProperties(_this$props, ["appendToBody", "trigger", "placement", "eventsEnabled", "popperModifiers", "delayMilliseconds", "type", "arrow", "children", "size", "zIndex"]);

      var _this$getControlledSt = this.getControlledState(),
          id = _this$getControlledSt.id;

      return external_react_default.a.createElement(containers_TooltipContainer, {
        appendToBody: appendToBody,
        id: id,
        placement: defaultPlacement,
        eventsEnabled: eventsEnabled,
        popperModifiers: popperModifiers,
        zIndex: zIndex,
        delayMilliseconds: delayMilliseconds,
        trigger: function trigger(_ref) {
          var getTriggerProps = _ref.getTriggerProps,
              ref = _ref.ref;
          var triggerElement = Object(external_react_["cloneElement"])(_trigger, getTriggerProps(_trigger.props));
          return external_react_default.a.createElement(TriggerWrapper, {
            innerRef: ref
          }, triggerElement);
        }
      }, function (_ref2) {
        var getTooltipProps = _ref2.getTooltipProps,
            placement = _ref2.placement;

        var tooltipProps = Tooltip_objectSpread({
          arrow: arrow,
          placement: placement,
          size: size
        }, otherProps);

        var TooltipElem = type === TYPE.LIGHT ? views_LightTooltip : views_TooltipView;
        return external_react_default.a.createElement(TooltipElem, getTooltipProps(tooltipProps), children);
      });
    }
  }]);

  return Tooltip;
}(react_selection_["ControlledComponent"]);

Tooltip_defineProperty(Tooltip_Tooltip, "propTypes", {
  /** Appends the tooltip to the body element */
  appendToBody: external_prop_types_default.a.bool,
  arrow: external_prop_types_default.a.bool,
  children: external_prop_types_default.a.node,

  /** Milliseconds of delay before open/close of tooltip is initiated */
  delayMilliseconds: external_prop_types_default.a.number,

  /** Whether Popper.js should update based on DOM resize events */
  eventsEnabled: external_prop_types_default.a.bool,
  id: external_prop_types_default.a.string,
  trigger: external_prop_types_default.a.node,

  /**
   * These placements differ from the default naming of Popper.JS placements to help
   * assist with RTL layouts.
   **/
  placement: external_prop_types_default.a.oneOf(['auto', 'top', 'top-start', 'top-end', 'end', 'end-top', 'end-bottom', 'bottom', 'bottom-start', 'bottom-end', 'start', 'start-top', 'start-bottom']),

  /** Passes options to [Popper.JS Instance](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#new-popperreference-popper-options) */
  popperModifiers: external_prop_types_default.a.object,
  size: external_prop_types_default.a.oneOf([Tooltip_SIZE.SMALL, Tooltip_SIZE.MEDIUM, Tooltip_SIZE.LARGE, Tooltip_SIZE.EXTRA_LARGE]),
  type: external_prop_types_default.a.oneOf([TYPE.LIGHT, TYPE.DARK]),

  /**
   * The z-index of the popper.js placement container
   */
  zIndex: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string])
});

Tooltip_defineProperty(Tooltip_Tooltip, "defaultProps", {
  arrow: true,
  eventsEnabled: true,
  type: TYPE.DARK
});


// CONCATENATED MODULE: ./src/views/content/Title.js
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */



var Title_COMPONENT_ID = 'tooltip.title';
/**
 * Accepts all `<div>` props
 */

var Title = external_styled_components_default.a.div.attrs({
  'data-garden-id': Title_COMPONENT_ID,
  'data-garden-version': "5.0.10",
  className: css_tooltips_dist_default.a['c-tooltip__title']
}).withConfig({
  displayName: "Title",
  componentId: "sc-2e1p7s-0"
})(["", ";"], function (props) {
  return Object(react_theming_["retrieveTheme"])(Title_COMPONENT_ID, props);
});
/** @component */

/* harmony default export */ var content_Title = (Title);
// CONCATENATED MODULE: ./src/views/content/Paragraph.js
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */



var Paragraph_COMPONENT_ID = 'tooltip.paragraph';
/**
 * Accepts all `<div>` props
 */

var Paragraph = external_styled_components_default.a.div.attrs({
  'data-garden-id': Paragraph_COMPONENT_ID,
  'data-garden-version': "5.0.10",
  className: css_tooltips_dist_default.a['c-tooltip__paragraph']
}).withConfig({
  displayName: "Paragraph",
  componentId: "sc-12kw068-0"
})(["", ";"], function (props) {
  return Object(react_theming_["retrieveTheme"])(Paragraph_COMPONENT_ID, props);
});
/** @component */

/* harmony default export */ var content_Paragraph = (Paragraph);
// CONCATENATED MODULE: ./src/index.js
/* concated harmony reexport Tooltip */__webpack_require__.d(__webpack_exports__, "Tooltip", function() { return Tooltip_Tooltip; });
/* concated harmony reexport TooltipContainer */__webpack_require__.d(__webpack_exports__, "TooltipContainer", function() { return containers_TooltipContainer; });
/* concated harmony reexport LightTooltip */__webpack_require__.d(__webpack_exports__, "LightTooltip", function() { return views_LightTooltip; });
/* concated harmony reexport TooltipView */__webpack_require__.d(__webpack_exports__, "TooltipView", function() { return views_TooltipView; });
/* concated harmony reexport Title */__webpack_require__.d(__webpack_exports__, "Title", function() { return content_Title; });
/* concated harmony reexport Paragraph */__webpack_require__.d(__webpack_exports__, "Paragraph", function() { return content_Paragraph; });
/* concated harmony reexport GARDEN_PLACEMENTS */__webpack_require__.d(__webpack_exports__, "GARDEN_PLACEMENTS", function() { return GARDEN_PLACEMENTS; });
/* concated harmony reexport POPPER_PLACEMENTS */__webpack_require__.d(__webpack_exports__, "POPPER_PLACEMENTS", function() { return POPPER_PLACEMENTS; });
/* concated harmony reexport getPopperPlacement */__webpack_require__.d(__webpack_exports__, "getPopperPlacement", function() { return getPopperPlacement; });
/* concated harmony reexport getRtlPopperPlacement */__webpack_require__.d(__webpack_exports__, "getRtlPopperPlacement", function() { return getRtlPopperPlacement; });
/**
 * Copyright Zendesk, Inc.
 *
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0.
 */








/***/ })
/******/ ])));
//# sourceMappingURL=index.js.map